import type { StorageResourceRef } from '../../../../types/azureStorage';

type Opener = (target?: StorageResourceRef) => void;
const openers = new Map<string, Opener>();

/**
 * S3's own action API for the Properties side panel (review C D6): the panel is per-tab S3 state, so S3's toolbar
 * button reaches it through the tab id S2's toolbar context carries (`capabilities.tabId`) instead of widening S2's
 * `openDialog(ReactNode)` contract. The tab registers its opener while mounted.
 */
export function registerStoragePropertiesOpener(tabId: string, opener: Opener): () => void {
  openers.set(tabId, opener);
  return () => {
    if (openers.get(tabId) === opener) openers.delete(tabId);
  };
}

export function openStoragePropertiesPanel(tabId: string | undefined, target?: StorageResourceRef): boolean {
  const opener = tabId ? openers.get(tabId) : undefined;
  opener?.(target);
  return !!opener;
}
